import { defineComponent as _defineComponent } from 'vue'
import EmptyStateEntry from '@/ui/pages/EmptyStateEntry';

export default /*#__PURE__*/_defineComponent({
  __name: 'CompletedCoursesEmpty',
  setup(__props) {

  
return { __sfc: true,EmptyStateEntry }
}

})